/**
 * Hook entry point for the shared formatting context. Lives in its own file
 * so `context.tsx` can keep `react-refresh/only-export-components` happy
 * (HMR requires component-only exports from a `.tsx` module).
 */

import { useContext } from 'react'
import { FormattingContext, type FormattingContextValue } from './context'

/**
 * Read the current org locale + currency. Always returns defaults when no
 * provider is mounted, so shared components are safe to call this without
 * guarding for an org context.
 */
export function useFormattingContext(): FormattingContextValue {
  return useContext(FormattingContext)
}
